import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import { MappingSummaryFooter } from 'components';
import { MappingContext } from 'contexts/MappingContext';
import type React from 'react';
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

type IMappingEditorFooterProps = {
  params: any;
};
const MappingEditorFooter: React.FC<IMappingEditorFooterProps> = ({ params }) => {
  const { pathname } = useLocation();
  const ctx = useContext(MappingContext);

  return (
    <FlexLayout justifyContent="space-between" alignItems="center" width="full">
      <Link
        to={pathname
          .split('/')
          .filter(i => i !== 'editor')
          .join('/')}
        style={{ textDecoration: 'none' }}
      >
        <FlexLayout alignItems="center">
          <Icon src="arrowBack" color="primaryText" stroke="transparent" />
          <H4 fontWeight="bold" color="primaryText" ml="xs">
            {ctx?.state.mappingEntity?.name}
          </H4>
        </FlexLayout>
      </Link>
      <MappingSummaryFooter />
    </FlexLayout>
  );
};

export default MappingEditorFooter;
